/**
 * 排序组件
 * Bai.Zhiming
 * 2019-6-24
 */
angular.module("fSortModule", []).
directive("fSort", ["$timeout", function($timeout) {
    return {
        restirct: "E",
        replace: true,
        scope: {
            status: "=",
            callback: "&"
        },
        template: `<div class="f_sort">
					<label ng-click="desc()" ng-class="{'active':status===-1}" class="iconfont desc icon-paixu"></label>
					<label ng-click="asc()" ng-class="{'active':status===1}" class="iconfont asc icon-paixu"></label>
				</div>`,
        link(scope, $element, $attrs) {
            /**
             * [desc description] 降序
             * @return {[type]} [description]
             */
            scope.desc = function() {
                scope.status = scope.status === -1 ? undefined : -1;
                $timeout(() => {
                    scope.callback();
                });
            };
            scope.asc = function() {
                scope.status = scope.status === 1 ? undefined : 1;
                $timeout(() => {
                    scope.callback();
                });
            };
        }
    };
}]);